import React from "react"
import { Alert } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { SnackbarContent, SnackbarKey, SnackbarMessage, useSnackbar } from "notistack"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    undoButton: {
        color: "white",
    },
    alert: {
        "& .MuiAlert-action": {
            padding: 0,
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
        },
        minWidth: 360,
        padding: "0.5rem 1rem",
        "& .MuiAlert-message": {
            fontSize: "1rem",
        },
        "& .MuiAlert-icon": {
            fontSize: "1.5rem",
        },
    },
}))

interface UndoSnackbarProps {
    id: SnackbarKey
    message: SnackbarMessage
    onUndo: () => void
    undoLabel: string
}

export const UNDO_TIMEOUT = 5000

const UndoSnackBar = React.forwardRef<HTMLDivElement, UndoSnackbarProps>(({ id, message, undoLabel, onUndo }, ref) => {
    const { classes } = useStyles()
    const { closeSnackbar } = useSnackbar()

    const handleUndo = async () => {
        await onUndo()
        closeSnackbar(id)
    }

    return (
        <SnackbarContent ref={ref}>
            <Alert
                severity="success"
                variant="filled"
                className={classes.alert}
                action={
                    <StandardButton className={classes.undoButton} size="small" onClick={handleUndo} variant="text">
                        {undoLabel}
                    </StandardButton>
                }
            >
                {message}
            </Alert>
        </SnackbarContent>
    )
})

export default UndoSnackBar
